const KEYBOARD_KEYS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
const TEL_NUMBER_REG_EXP = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
const COUNTRIES_CODES = [
    {
        locale: 'nb',
        name: 'Norway',
        code: '+47'
    },
    {
        locale: 'sv',
        name: 'Sweden',
        code: '+46'
    },
    {
        locale: 'en',
        name: 'England',
        code: '+44'
    },
];

export {
    KEYBOARD_KEYS,
    COUNTRIES_CODES,
    TEL_NUMBER_REG_EXP
};
